var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-group"},[_c('video',{staticClass:"video",attrs:{"src":_vm.url,"controls":"","autoplay":""}}),_c('i',{staticClass:"el-icon-circle-close close",on:{"click":_vm.closeVideo}})])}
var staticRenderFns = []

export { render, staticRenderFns }